import { Box, Button } from '@mui/material';
import DatePicker from '../../form/components/DatePicker.component';
import AsyncAutocomplete from '../../form/components/AsyncAutocomplete.component';
import { API as departments } from '../../../module/departments/api';

const FilterControls = ({
  children,
  onApplyFilter,
  onFilterToday,
  onResetFilters,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexDirection: { xs: 'column', xl: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {children}
      <Box
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: 'lightgray',
          display: { xs: 'block', md: 'none' },
        }}
      />

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Box sx={{ width: { xs: '100%', md: '40%' } }}>
            <DatePicker label='Start Date' id='start_date' name='start_date' />
          </Box>
          <Box sx={{ width: { xs: '100%', md: '40%' } }}>
            <DatePicker label='End Date' id='end_date' name='end_date' />
          </Box>
          <Box sx={{ width: { xs: '100%', md: '40%' } }}>
            <AsyncAutocomplete
              id='id_department'
              label='Department'
              name='id_department'
              api={departments.logbookDepartments}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexDirection: { xs: 'column', md: 'row' },
            width: { xs: '100%', md: 'auto' },
            height: { md: '52px' },
          }}
        >
          <Button
            variant={'outlined'}
            onClick={onFilterToday}
            sx={{ borderRadius: '10px', minWidth: '120px' }}
          >
            Today
          </Button>
          <Button
            variant={'outlined'}
            onClick={onApplyFilter}
            sx={{ borderRadius: '10px', minWidth: '120px' }}
          >
            Apply Filters
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={onResetFilters}
            sx={{ borderRadius: '10px', minWidth: '120px' }}
          >
            Reset
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterControls;
